import { Controller } from "@hotwired/stimulus";

// One flash message. The x button dismisses it; with autofade on (notices) it
// also fades out after a few seconds. Alerts leave autofade off and stay put.
export default class extends Controller {
  static values = {
    autofade: { type: Boolean, default: false },
    delay: { type: Number, default: 5000 },
  };

  connect() {
    if (this.autofadeValue) {
      this.timer = setTimeout(() => this.fadeOut(), this.delayValue);
    }
  }

  disconnect() {
    clearTimeout(this.timer);
  }

  dismiss() {
    clearTimeout(this.timer);
    this.element.remove();
  }

  fadeOut() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.element.remove();
      return;
    }

    this.element.classList.add("opacity-0");
    // transitionend can be skipped (hidden tab, no transition), so back it up.
    this.element.addEventListener("transitionend", () => this.element.remove(), { once: true });
    this.timer = setTimeout(() => this.element.remove(), 700);
  }
}
